<template>
  <hcc-modal
    name="transfer-conversation-modal"
    :title="$t('transfer-conversation.title')"
    @opened="openModal"
    @cancel="handleCancel"
    @closed="handleCancel"
    @confirm="handleConfirm"
    :hideOnConfirm="!hasError"
    :buttons="['cancel', 'confirm']"
    :width="800"
    :customClassBody="bodyClass"
    :scrollable="false"
    :confirmDisableButton="disableConfirmButton"
  >
    <div :class="[containerClass, { scroll: rows.length > 3 }]" @click.stop>
      <hcc-checkbox-table
        :columns="columns"
        :search="true"
        :rows="rows"
        :campaignId="campaignId"
        :rowsPerPage="100"
        @checkedRow="selectedRow"
        @selectedCampaign="selectedCampaign"
      />
      <transition name="fade" v-if="showAlert">
        <div class="warning">
          {{ alertMessage }}
        </div>
      </transition>
    </div>
  </hcc-modal>
</template>

<script>
import getAgents from '@/graphql/queries/getAgents.gql';
import HccModal from '@/components/shared/HccModal/index.vue';
import HccCheckboxTable from '@/components/shared/HccTable/TransferConversationTable.vue';

export default {
  props: {
    campaignId: {
      required: true,
      type: String,
    },
    request: {
      required: true,
      type: Boolean,
    },
  },
  components: {
    HccModal,
    HccCheckboxTable,
  },
  data() {
    return {
      selectCampaign: '',
      users: [],
      rows: [],
      selectUser: '',
      windowHeight: window.innerHeight,
      showAlert: false,
      alert: null,
    };
  },
  computed: {
    disableConfirmButton() {
      return !this.selectUser && !this.selectCampaign;
    },
    columns() {
      return [
        {
          label: this.$t('transfer-conversation.select'),
          field: 'select',
        },
        {
          label: this.$t('transfer-conversation.user'),
          field: 'name',
        },
        {
          label: this.$t('campaigns.title'),
          field: 'campaigns',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ];
    },
    containerClass() {
      return this.windowHeight < 700 ? 'container-small' : 'container';
    },
    bodyClass() {
      return this.windowHeight < 700 ? 'body-small' : 'body';
    },
    alertMessage() {
      return !this.selectCampaign ? this.$t('transfer-conversation.select-campaign')
        : this.$t('transfer-conversation.select-agent');
    },
    hasError() {
      return !this.selectUser || !this.selectCampaign;
    },
  },
  watch: {
    request(newVal) {
      this.selectUser = '';
      this.selectCampaign = '';
      if (newVal) {
        this.buildUserTable();
      }
    },
  },
  created() {
    window.addEventListener('resize', this.updateHeight);
  },
  beforeDestroy() {
    clearInterval(this.alert);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateHeight);
  },
  methods: {
    selectedCampaign({ row: user, campaign }) {
      if (!this.selectUser) {
        this.selectCampaign = campaign.id;
      } else if (this.selectUser === user.id) {
        this.selectCampaign = campaign.id;
      }
    },
    async buildUserTable() {
      const users = await this.loadOnlineUsers();
      this.rows = users.map((user) => ({ ...user, selected: false }));
    },
    handleConfirm() {
      if (this.hasError) {
        this.showAlert = true;
        this.alert = setInterval(() => {
          this.showAlert = false;
        }, 2000);
      } else {
        this.$emit('confirm', {
          userId: this.selectUser,
          campaignId: this.selectCampaign,
        });
      }
    },
    handleCancel() {
      this.selectCampaign = '';
      this.selectUser = '';
      this.$emit('cancel');
    },
    async loadOnlineUsers() {
      const { data: response } = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: getAgents,
        variables: { campaignId: this.campaignId },
      });
      return response.getOnlineAgents;
    },
    selectedRow({ row, campaign }) {
      if (!row.selected) {
        this.selectUser = row.id;

        if (campaign) {
          this.selectCampaign = campaign.id;
        }
      } else {
        this.selectUser = '';
      }

      this.rows = this.rows.map((user) => (user.id === row.id
        ? { ...user, selected: !row.selected }
        : { ...user, selected: false }));
    },
    updateHeight() {
      this.windowHeight = window.innerHeight;
    },
    openModal() {
      this.selectUser = '';
      this.selectCampaign = '';
    },

  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/transfer-conversation-modal.scss";
</style>
